import { RefObject, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { logger } from 'helpers/logger'
import { wsSlice } from '../../wsSlice'
import ReconnectingWebSocket from 'reconnecting-websocket'
import { WsSubscribeMessage } from '../../types'
import { getTopics } from '../helpers/getTopics'
type UseSubscribeProps = {
  isReady: boolean
  socket: ReconnectingWebSocket | null
  serverSubscriptions: RefObject<WsSubscribeMessage[]>
}

export const useSubscribe = ({
  isReady,
  socket,
  serverSubscriptions,
}: UseSubscribeProps) => {
  const subscribers = useSelector(wsSlice.selectors.selectSubscribers)

  useEffect(() => {
    if (isReady) {
      logger.debug('WebSocket subscribers list: ', subscribers)

      const newSubscriptions = subscribers.filter(
        (s) => !serverSubscriptions.current?.includes(s),
      )

      const topics = getTopics(newSubscriptions)

      if (topics.length > 0) {
        try {
          socket?.send(
            JSON.stringify({
              type: 'SUBSCRIBE',
              topics,
            }),
          )

          serverSubscriptions.current?.push(...newSubscriptions)
          logger.debug('WebSocket subscribed to: ', topics)
        } catch (e) {
          logger.error('WebSocket error when send: ', e)
        }
      }
    }
  }, [isReady, subscribers])
}
